/**
 * 인사마스터 우측 상세 영역 — 1차 탭 구성 (더존 사원등록 레이아웃 참고)
 *
 * 기관별 탭 숨김(추후):
 * - common code / 환경설정에서 숨길 탭 id 목록을 내려주면
 *   resolveMasterDetailTabs({ hiddenTabIds }) 로 필터링한다.
 * - 예) code_group = 'HR_MASTER_TAB', code = 탭 id, use_yn = 'N' → 숨김
 */

/** @typedef {{ id: string, label: string, visible?: boolean, placeholder?: boolean }} MasterDetailTabDef */

/** @type {MasterDetailTabDef[]} */
export const MASTER_DETAIL_TAB_DEFS = [
  { id: 'basic1', label: '기본정보1', visible: true },
  { id: 'basic2', label: '기본정보2', visible: true },
  { id: 'payroll', label: '급여기초', visible: true, placeholder: true },
  { id: 'personal', label: '인적사항', visible: true, placeholder: true },
  { id: 'records', label: '인사기록카드', visible: true },
];

/**
 * 기관/환경설정 기준으로 표시할 탭 목록
 * @param {{ tenantCode?: string, hiddenTabIds?: string[] }} [opts]
 * @returns {MasterDetailTabDef[]}
 */
export function resolveMasterDetailTabs(opts = {}) {
  const hidden = new Set(
    (opts.hiddenTabIds || [])
      .map((id) => String(id || '').trim())
      .filter(Boolean)
  );

  // 추후: tenantCode 로 공통코드/환경설정 API 조회 후 hidden 에 병합
  // const fromServer = await fetchHrMasterHiddenTabs(opts.tenantCode);

  return MASTER_DETAIL_TAB_DEFS.filter((tab) => {
    if (tab.visible === false) return false;
    if (hidden.has(tab.id)) return false;
    return true;
  });
}

/**
 * 로컬/임시 숨김 탭 (개발·데모용). 운영에서는 공통코드로 대체.
 * localStorage key: hr.master.hiddenTabs = ["payroll","personal"]
 */
export function loadHiddenMasterTabsFromLocal() {
  try {
    const raw = window.localStorage.getItem('hr.master.hiddenTabs');
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
}
